import { Label } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { ChooseAmountInputWithSlider } from '../../../../ui/ChooseAmountInputWithSlider/ChooseAmountInputWithSlider';

export const ChooseAmount = ({
    selectedAmount,
    setSelectedAmount,
    maxAmount
}: {
    selectedAmount: number | null;
    setSelectedAmount: (amount: number) => void;
    maxAmount: number;
}) => {
    return (
        <ChooseAmountInputWithSlider
            label={
                <Label className="text-xl font-bold" htmlFor="choose-amount">
                    <FormattedMessage
                        id="_.topup_choice.approved_choose_amount_label"
                        defaultMessage="I want to borrow an additional"
                    />
                </Label>
            }
            selectedAmount={selectedAmount}
            onChange={(value) => setSelectedAmount(value)}
            maxAmount={maxAmount}
        />
    );
};
